import React, { useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext, DrawerContext } from 'commons-ui';
import { ACTION_IDS } from './constants';
import {
	UnsetPhoneContent,
	BlockUserContent,
	UnblockUserContent,
	UpdateUserFraudStatus,
	UserLevelUpdateContent,
	ViewDobContent,
	ViewPhoneContent,
	ViewEmailContent,
	CancelSubscriptionContent
} from './components';
import ViewAlternatePhoneContent from './components/viewAlternatePhone/Content';
import UpdateAlternatePhoneContent from './components/updateAlternatePhone/Content';
import BlockUnblockDetails from './components/blockUnblockDetails';
import { UPDATE_USER_FRAUD_STATUS_ADMIN_ACTION_TYPES } from './components/utils/constants';

export const makeActionHandler = (actionId: string, params: any) => {
	const { handleForceUpdate, getBlockUnblockDetails, keyData, setKeyData } = params;
	const { setModalConfig } = useContext(ModalContext);
	const { setDrawerConfig } = useContext(DrawerContext);

	switch (actionId) {
		case ACTION_IDS.UNSET_PHONE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Unset Phone Number',
					content: <UnsetPhoneContent handleForceUpdate={handleForceUpdate} />
				});
			};
		case ACTION_IDS.BLOCK_USER:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Block User',
					content: <BlockUserContent handleForceUpdate={handleForceUpdate} />
				});
			};
		case ACTION_IDS.UNBLOCK_USER:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Unblock User',
					content: <UnblockUserContent handleForceUpdate={handleForceUpdate} />
				});
			};
		case ACTION_IDS.MARK_USER_FRAUD:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Mark This User as Fraud',
					content: (
						<UpdateUserFraudStatus
							handleForceUpdate={handleForceUpdate}
							adminActionType={UPDATE_USER_FRAUD_STATUS_ADMIN_ACTION_TYPES.MARK_USER_FRAUD}
						/>
					)
				});
			};
		case ACTION_IDS.UNMARK_USER_FRAUD:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Unmark This User as Fraud',
					content: (
						<UpdateUserFraudStatus
							handleForceUpdate={handleForceUpdate}
							adminActionType={UPDATE_USER_FRAUD_STATUS_ADMIN_ACTION_TYPES.UNMARK_USER_FRAUD}
						/>
					)
				});
			};
		case ACTION_IDS.BLOCK_UNBLOCK_DETAILS:
			return () => {
				setDrawerConfig({
					isOpen: true,
					content: <BlockUnblockDetails getBlockUnblockDetails={getBlockUnblockDetails} />
				});
			};
		case ACTION_IDS.USER_LEVEL_UPDATE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Update User Level',
					content: <UserLevelUpdateContent handleForceUpdate={handleForceUpdate} currentUserLevel={keyData} />
				});
			};
		case ACTION_IDS.VIEW_DOB:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'View DOB',
					content: <ViewDobContent setKeyData={setKeyData} />
				});
			};
		case ACTION_IDS.VIEW_PHONE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'View Phone Number',
					content: <ViewPhoneContent setKeyData={setKeyData} />
				});
			};
		case ACTION_IDS.VIEW_ALTERNATE_PHONE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'View Alternate Phone Number',
					content: <ViewAlternatePhoneContent setKeyData={setKeyData} />
				});
			};
		case ACTION_IDS.UPDATE_ALTERNATE_PHONE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Update Alternate Phone Number',
					content: <UpdateAlternatePhoneContent handleForceUpdate={handleForceUpdate} />
				});
			};
		case ACTION_IDS.VIEW_EMAIL:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'View Email',
					content: <ViewEmailContent setKeyData={setKeyData} />
				});
			};
		case ACTION_IDS.CANCEL_SUBSCRIPTION:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Cancel Subscription',
					content: <CancelSubscriptionContent handleForceUpdate={handleForceUpdate} />
				});
			};
		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
